<template>
    <div class="app-modal-dialog--ai-relay app-modal-dialog">
        <div class="app-modal-dialog__content">
            <div class="app-modal-dialog__header">
                <div class="app-modal-dialog__titles">
                    <div class="app-tab-navigation">
                        <div class="app-tab-navigation__breadcrumbs">
                            <a class="app-tab-navigation__breadcrumb" :href="`/publications/${publication.id}/ai-sources`">
                                <svg class="element-icon--breadcrumb element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-breadcrumb"></use></svg>
                                File Upload
                            </a>
                            <svg class="element-icon--chevron-right element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-chevron-right"></use></svg>
                            <div class="app-tab-navigation__breadcrumb is--active">Course Outline</div>
                        </div>
                    </div>
                    <h4 class="app-modal-dialog__title">AI Generation: {{ this.publication.name }}
                        <!-- <span type="button" class="float-right"
                                data-toggle="modal"
                                data-target="#ai-help-modal"
                                data-backdrop="static">
                                <i class="icon-info"></i>
                        </span> -->
                    </h4>
                    <p class="app-modal-dialog__section-instructions">When you're satisfied with your outline after conversing with the AI, select "Validate Outline" to create a JSON. Then, select "Create Outline." Once you select "Save Course," you can to view the new learning objects in the "Content" tab.</p>
                </div>
            </div>
            <div class="app-modal-dialog__body">

                <form class="ai-console" @submit.prevent="execute()">
                <ai-relay-history
                    @removeItemFromHistory="onHistoryItemRemove($event)"
                    :source="history">
                </ai-relay-history>
                <div class="app-modal-dialog__ai-relay-input-group">
                    <div class="input textarea">
                        <textarea
                        type="textarea"
                        rows="5"
                        v-model="command"
                        @keydown="onTextAreaKeyDown($event)"
                        ref="input"></textarea>
                    </div>
                    <button
                        @click="execute()"
                        :disabled="!command || isProcessing"
                        type="button"
                        class="element-button--icon element-button">
                        <svg class="element-icon--send element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-send"></use></svg>
                    </button>
                </div>
                
                <div class="app-modal-dialog__ai-relay-footer-grouping">
                    <p>Using files: <b>{{ hasMedia }}</b></p>
                    <p>Using Internet content: <b>{{ internetContentLabel }}</b></p>
                </div>
            </form>
            <div class="app-modal-dialog__footer">
                <a class="element-button--secondary element-button" 
                    :href="`/projects/${project.id}/publications`">
                    Close
                </a>
                <button
                    v-if="!outlineValidated"
                    @click="parseOutline()"
                    :disabled="isProcessing"
                    type="button"
                    class="element-button--primary element-button">
                    Validate Outline
                </button>
                <button
                    v-if="outlineValidated"
                    @click="generate()"
                    :disabled="!outlineValidated || isProcessing"
                    type="button"
                    class="element-button--primary element-button">
                    Create Outline
                </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import api from '../api/ai'
import AiRelayHistory from './AiRelayHistory'

export default {
    components: {
        AiRelayHistory
    },
    props: {
        project: {
            type: Object
        },
        publication: {
            type: Object
        },
        settings: {
            type: Object
        }
    },
    data () {
        return {
            command: '',
            isProcessing: false,
            outlineValidated: (this.publication.ai_preferences?.outline) ? true : false,
            sessionId: this.publication?.latest_ai_session?.guid ?? false,
            history: this.publication?.latest_ai_session?.messages ?? []
        }
    },
    watch: {
    },
    computed: {
        internetContentLabel () {
            return this.publication?.ai_preferences?.dismissAi ? 'No' : 'Yes'
        },
        hasMedia () {
            return this.publication?.media?.length ? 'Yes' : 'No'
        }
    },
    methods: {
        onTextAreaKeyDown (event) {
            // Check if the 'Enter' key was pressed
            if (event.key === 'Enter') {
                // If 'Shift' is not being held down, prevent the default behavior
                if (!event.shiftKey) {
                    event.preventDefault()
                    this.execute()
                }
            }
        },
        async onHistoryItemRemove (messageIds) {
            console.log('remove messages')
            console.log(messageIds)

            try {
                var params = { messages: messageIds };

                const response = await api.removeMessages(this.sessionId, params)
                if (response?.status === 'error')
                {
                    console.error(response)
                    alert(response?.errors)
                }
                else
                {
                    console.log(response)
                    this.history = response.messages
                }
            } catch (err) {
                console.error(err.response)
                alert('unable to remove messages')
            }
        },
        async execute (_command) {

            if (this.isProcessing)
                return false

            const command = _command ?? this.command

            if (!command || command.trim() === '')
                return false;

            this.command = ''
            this.isProcessing = true
            this.outlineValidated = false

            const item = {
                user_query: command,
                ai_response: 'Waiting on response',
                loading: true
            }

            this.history.push(item)

            const data = {
                sessionId:this.sessionId,
                prompt:command,
            }
            let result = false;
            try {
                const response = await api.execute(`${this.publication.id}`, data)
                result = _.get(response, 'data')
                if (response?.status === 'error')
                {
                    console.error(response)
                    alert(response?.errors)
                }
                else
                {
                    if (result) {
                        if (result?.latest_ai_session?.messages)
                        {
                            this.history = result.latest_ai_session.messages;
                        }
                    }
                }
            } catch (err) {
                // TODO: handle error
                // replace last item with error message
                console.error(err.response)
            }
            this.isProcessing = false

            return result;
        },
        async parseOutline () {

            const command = this.settings['ai-prompt--outline-json'];
            const result = await this.execute(command);

            if (result !== false)
            {
                this.outlineValidated = true
            }
            else // TODO: handle error
            { }

            this.isProcessing = false
        },
        async generate () {
            this.isProcessing = true

            // TODO: call route to create a job and pass the json outline
            // change status/lock for processing, redirect to status page
            try {
                const response = await api.generate(`${this.publication.id}`)
                // result = _.get(response, 'data')
                console.log(response)
                window.location.href = '/projects/' + this.project.id + '/publications/' + this.publication.id + '/edit';
            } catch (err) {
                console.error(err)
                alert('Something went wrong, unable to create outline')
            }
            this.isProcessing = false
        }
    }
}
</script>
